<script>
function parseJsonResponse(res) {
  return res.text().then(function (text) {
    var data = {};
    try {
      data = text ? JSON.parse(text) : {};
    } catch (err) {
      data = { success: false, message: text || "API response ไม่ถูกต้อง" };
    }
    if (!res.ok) {
      throw new Error(data.message || "Request failed");
    }
    return data;
  });
}

function quillToolbar() {
  return [
    ["bold", "italic", "underline"],
    [{ header: [2, 3, false] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ];
}

export default {
  name: "AdminSettingsApproveMail",
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    var settings = (this.config && this.config.settings) || {};
    return {
      form: {
        approve_mail_subject: String(settings.approve_mail_subject || ""),
        approve_mail_body: String(settings.approve_mail_body || ""),
      },
      defaults: {
        subject: String(settings.approve_mail_default_subject || ""),
        body: String(settings.approve_mail_default_body || ""),
      },
      placeholders: Array.isArray(settings.placeholders) ? settings.placeholders : [],
      fromDb: !!settings.from_db,
      saving: false,
      alert: { type: "", message: "" },
      quill: null,
    };
  },
  computed: {
    saveUrl: function () {
      return String((this.config && this.config.saveUrl) || "actions/admin/settings-save.php");
    },
  },
  mounted: function () {
    this.initEditor();
  },
  beforeUnmount: function () {
    this.quill = null;
  },
  methods: {
    applySettings: function (settings) {
      var s = settings && typeof settings === "object" ? settings : {};
      this.form.approve_mail_subject = String(s.approve_mail_subject || "");
      this.form.approve_mail_body = String(s.approve_mail_body || "");
      this.fromDb = !!s.from_db;
      if (Array.isArray(s.placeholders)) {
        this.placeholders = s.placeholders;
      }
      if (this.quill) {
        this.quill.root.innerHTML = this.form.approve_mail_body || "<p><br></p>";
      }
    },
    initEditor: function () {
      var el = this.$refs.editor;
      if (!el || !window.Quill) {
        this.alert = { type: "danger", message: "ไม่พบตัวแก้ไขข้อความ (Quill) — รีเฟรชหน้าแล้วลองใหม่" };
        return;
      }
      this.quill = new window.Quill(el, {
        theme: "snow",
        modules: { toolbar: quillToolbar() },
      });
      this.quill.root.innerHTML = this.form.approve_mail_body || "<p><br></p>";
      var self = this;
      this.quill.on("text-change", function () {
        self.form.approve_mail_body = self.quill.root.innerHTML;
      });
    },
    insertPlaceholder: function (token) {
      if (!this.quill) {
        this.form.approve_mail_body += String(token || "");
        return;
      }
      var range = this.quill.getSelection(true);
      var index = range && typeof range.index === "number" ? range.index : this.quill.getLength();
      this.quill.insertText(index, String(token || ""), "user");
      this.quill.setSelection(index + String(token || "").length, 0);
    },
    restoreDefault: function () {
      this.form.approve_mail_subject = this.defaults.subject;
      this.form.approve_mail_body = this.defaults.body;
      if (this.quill) {
        this.quill.root.innerHTML = this.defaults.body || "<p><br></p>";
      }
    },
    save: function () {
      var self = this;
      if (this.quill) {
        this.form.approve_mail_body = this.quill.root.innerHTML;
      }
      this.saving = true;
      this.alert = { type: "", message: "" };
      var body = new FormData();
      body.append("section", "approve_mail");
      body.append("approve_mail_subject", this.form.approve_mail_subject);
      body.append("approve_mail_body", this.form.approve_mail_body);
      fetch(this.saveUrl, { method: "POST", body: body, credentials: "same-origin" })
        .then(parseJsonResponse)
        .then(function (data) {
          if (!data || data.success !== true) {
            throw new Error((data && data.message) || "บันทึกไม่สำเร็จ");
          }
          if (data.settings) {
            self.applySettings(data.settings);
          }
          self.alert = { type: "success", message: data.message || "บันทึกเนื้อหาอีเมลแล้ว" };
        })
        .catch(function (e) {
          self.alert = { type: "danger", message: e.message || "เกิดข้อผิดพลาด" };
        })
        .finally(function () {
          self.saving = false;
        });
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
          <h4 class="mb-sm-0">เนื้อหาอีเมลอนุมัติใบสมัคร</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript:void(0);">ผู้ดูแลระบบ</a></li>
              <li class="breadcrumb-item"><a href="main-admin.php?page=settings">ตั้งค่าระบบ</a></li>
              <li class="breadcrumb-item active">อีเมลอนุมัติใบสมัคร</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div v-if="alert.message" class="alert alert-dismissible fade show" :class="alert.type === 'success' ? 'alert-success' : 'alert-danger'" role="alert">
      {{ alert.message }}
      <button type="button" class="btn-close" aria-label="Close" @click="alert.message = ''"></button>
    </div>

    <form autocomplete="off" @submit.prevent="save">
      <div class="row">
        <div class="col-xl-10">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title mb-0">ข้อความที่ส่งเมื่ออนุมัติใบสมัคร</h4>
            </div>
            <div class="card-body">
              <p class="text-muted">แก้ไขหัวข้อและเนื้อหาผ่านตัวแก้ไขข้อความ ใช้ตัวแปรด้านล่างเพื่อแทรกข้อมูลผู้สมัครตอนส่งเมล</p>
              <div class="mb-3">
                <label class="form-label" for="mct-approve-mail-subject">หัวข้ออีเมล</label>
                <input id="mct-approve-mail-subject" v-model="form.approve_mail_subject" type="text" class="form-control" required>
              </div>
              <div class="mb-2">
                <span class="form-label d-block mb-1">แทรกตัวแปร</span>
                <div class="d-flex flex-wrap gap-1">
                  <button
                    v-for="item in placeholders"
                    :key="item.token"
                    type="button"
                    class="btn btn-sm btn-soft-primary"
                    :title="item.label"
                    @click="insertPlaceholder(item.token)"
                  >{{ item.token }}</button>
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label">เนื้อหาอีเมล</label>
                <div class="mct-mail-editor border rounded bg-white">
                  <div ref="editor"></div>
                </div>
              </div>
              <p v-if="!fromDb" class="form-text mb-0">ยังไม่ได้บันทึกในฐานข้อมูล — กำลังใช้ข้อความเริ่มต้นของระบบ</p>
              <p v-else class="form-text mb-0">ค่านี้มาจากฐานข้อมูล และจะใช้ทุกครั้งที่อนุมัติใบสมัคร</p>
            </div>
          </div>
          <div class="d-flex flex-wrap gap-2">
            <button type="submit" class="btn btn-success" :disabled="saving">
              {{ saving ? "กำลังบันทึก..." : "บันทึกเนื้อหาอีเมล" }}
            </button>
            <button type="button" class="btn btn-soft-secondary" :disabled="saving" @click="restoreDefault">คืนค่าข้อความเริ่มต้น</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<style>
.mct-mail-editor .ql-toolbar.ql-snow {
  border: 0;
  border-bottom: 1px solid var(--vz-border-color, #e9ebec);
}
.mct-mail-editor .ql-container.ql-snow {
  border: 0;
}
.mct-mail-editor .ql-editor {
  min-height: 280px;
  font-family: Kanit, "Noto Sans Thai", sans-serif;
  font-size: 1rem;
  line-height: 1.75;
}
</style>
